import React from "react";
import { Calendar } from "lucide-react";
import { RequestItem, TaskSchedule } from "../../../api/requests";
import type { CheckDetailKind } from "../checkDetailKind";
import { formatDate, formatLastPing } from "../requestDetailUtils";

export interface RequestDetailInfoCardProps {
  kind?: CheckDetailKind;
  data: RequestItem;
  isEditingRequest: boolean;
  editCompanyName: string;
  editInn: string;
  editUrl: string;
  schedulePeriodicityLabel: string | null;
  scheduleItem: TaskSchedule | null;
  setEditCompanyName: React.Dispatch<React.SetStateAction<string>>;
  setEditInn: React.Dispatch<React.SetStateAction<string>>;
  setEditUrl: React.Dispatch<React.SetStateAction<string>>;
  handleOpenRunsCalendar: () => void;
}

export const RequestDetailInfoCard: React.FC<RequestDetailInfoCardProps> = ({
  kind = "site",
  data,
  isEditingRequest,
  editCompanyName,
  editInn,
  editUrl,
  schedulePeriodicityLabel,
  scheduleItem,
  setEditCompanyName,
  setEditInn,
  setEditUrl,
  handleOpenRunsCalendar,
}) => (
  <div className="detail-card">
    <div className="detail-row">
      <span className="detail-label">{kind === "it" ? "Продукт" : "Компания"}</span>
      {isEditingRequest ? (
        <input
          type="text"
          className="detail-edit-input"
          value={editCompanyName}
          onChange={(e) => setEditCompanyName(e.target.value)}
        />
      ) : (
        <span className="detail-value">{data.companyName}</span>
      )}
    </div>
    {kind !== "it" ? (
      <div className="detail-row">
        <span className="detail-label">ИНН</span>
        {isEditingRequest ? (
          <input
            type="text"
            className="detail-edit-input"
            value={editInn}
            onChange={(e) => setEditInn(e.target.value)}
          />
        ) : (
          <span className="detail-value">{data.inn}</span>
        )}
      </div>
    ) : null}
    <div className="detail-row">
      <span className="detail-label">URL</span>
      {isEditingRequest ? (
        <input
          type="text"
          className="detail-edit-input"
          value={editUrl}
          onChange={(e) => setEditUrl(e.target.value)}
        />
      ) : (
        <a
          href={data.url.startsWith("http") ? data.url : `https://${data.url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="detail-url"
        >
          {data.url}
        </a>
      )}
    </div>
    {data.available != null && (
      <>
        <div className="detail-row">
          <span className="detail-label">Сайт</span>
          <span
            className={`detail-value${data.available ? "" : " detail-value--unavailable"}`}
          >
            {data.available ? "Доступен" : "Недоступен"}
          </span>
        </div>
        {data.lastPing && (
          <div className="detail-row">
            <span className="detail-label">Последняя проверка доступности сайта</span>
            <span className="detail-value">{formatLastPing(data.lastPing)}</span>
          </div>
        )}
      </>
    )}
    {schedulePeriodicityLabel && (
      <div className="detail-row">
        <span className="detail-label">Периодичность</span>
        <span className="detail-value">{schedulePeriodicityLabel}</span>
      </div>
    )}
    {scheduleItem?.nextRunAt && (
      <div className="detail-row">
        <span className="detail-label">Запланирована проверка</span>
        <span className="detail-value detail-value--schedule-next">
          <span>{formatDate(scheduleItem.nextRunAt)}</span>
          {scheduleItem.id ? (
            <button
              type="button"
              className="detail-schedule-next-cal-btn"
              onClick={handleOpenRunsCalendar}
              aria-label="Календарь запусков"
            >
              <Calendar size={18} strokeWidth={1.75} />
            </button>
          ) : null}
        </span>
      </div>
    )}
  </div>
);
